import { Component, OnDestroy, OnInit } from '@angular/core';
import { TimeOffApprovalFlow } from '@app/models/time-off-v3/time-off-approval-flow.model';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { TimeOffCreateFlowService } from '@app/modules/time-off-v3/services';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-basic-info-form',
    templateUrl: 'basic-info.template.html',
    styles: [
        `
            form {
                --form-field-label-left-margin: 0;
            }
        `,
    ],
})
export class BasicInfoForm extends BaseForm implements OnInit, OnDestroy {
    timeOffPolicy = new TimeOffPolicy();
    timeOffType = new TimeOffType();
    timeOffTypes: TimeOffType[] = [];
    timeOffApprovalFlows: TimeOffApprovalFlow[] = [];
    showTimeOffTypeForm = false;

    private timeOffTypesSubscription!: Subscription;
    private timeOffApprovalFlowsSubscription!: Subscription;
    private timeOffTypeSubscription!: Subscription;
    private timeOffPolicySubscription!: Subscription;

    constructor(public timeOffCreateFlowService: TimeOffCreateFlowService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.timeOffTypesSubscription = this.timeOffCreateFlowService.timeOffTypes$.subscribe((types) => {
            this.timeOffTypes = types;
        });

        this.timeOffApprovalFlowsSubscription = this.timeOffCreateFlowService.timeOffApprovalFlows$.subscribe(
            (flows) => {
                this.timeOffApprovalFlows = flows;
            }
        );

        this.timeOffPolicySubscription = this.timeOffCreateFlowService.timeOffPolicy$.subscribe((policy) => {
            this.timeOffPolicy = policy;
        });

        this.timeOffTypeSubscription = this.timeOffCreateFlowService.timeOffType$.subscribe((type) => {
            this.timeOffType = type;
        });
    }

    updateTimeOffPolicy(): void {
        this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
        this.timeOffCreateFlowService.updateTimeOffType(this.timeOffPolicy.timeOffType);
    }

    ngOnDestroy(): void {
        this.timeOffTypesSubscription.unsubscribe();
        this.timeOffApprovalFlowsSubscription.unsubscribe();
        this.timeOffPolicySubscription.unsubscribe();
        this.timeOffTypeSubscription.unsubscribe();
    }
}
